import { IMAGES } from '../configs/configs'

export const Solid = (icon) => `${IMAGES.URL}/solid/${icon}.svg`
export const Outlined = (icon) => `${IMAGES.URL}/outlined/${icon}.svg`
